import { VStack } from "@chakra-ui/react";
import { TreatmentPieChart } from "../pie-chart/TreatmentPieChart";
import { AttributePieChart } from "../pie-chart/AttributePieChart";
import { ScorePieChart } from "./ScorePieChart";
import { AttributeDefinitions } from "@keita/lanepatrol-sdk";
import { ColorBy, ColorByType } from "../../../../map/models/ColorBy";

interface Props {
  colorBy: ColorBy;
}

export const MultiContextPieChart: React.FC<Props> = ({ colorBy }) => {
  const renderContent = () => {
    switch (colorBy.type) {
      case ColorByType.Treatment:
        return <TreatmentPieChart treatmentType={colorBy.treatmentType} />;
      case ColorByType.Attribute:
        return (
          <AttributePieChart
            attributeDefinition={
              AttributeDefinitions.getByName(colorBy.attributeName)!
            }
          />
        );
      case ColorByType.Score:
        return <ScorePieChart crashType={colorBy.scoreKey} />;
    }
  };

  return <VStack fontSize="sm">{renderContent()}</VStack>;
};
